<template>
  <div>
    <div><CustomLoader v-if="isLoading" :width="70"></CustomLoader></div>
    <b-card class="mainCardBG">
      <div class="gutr mt-3">
        <div class="row">
          <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
            <div>
              <b-navbar toggleable="lg" type="dark" variant="info">
                <b-navbar-brand style="padding: 0.475rem 1rem">
                  <transition name="custom-slide" mode="out-in">
                    <h3>{{ $route.name }}</h3>
                  </transition>
                </b-navbar-brand>

                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button-group size="sm" class="ml-1 text-right">
                      <b-button variant="outline-secondary" @click="goBack"
                        >Back</b-button
                      >
                    </b-button-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>

              <div>
                <b-card>
                  <b-row>
                    <b-col md="12">
                      <div class="tab-list d-flex">
                        <div
                          v-for="(tab, index) in tabs"
                          :key="index"
                          :class="{ 'active-tab': activeTab === index }"
                          @click="changeTab(index)"
                        >
                          {{ tab.name }}
                        </div>
                      </div>

                      <transition name="custom-slide" mode="out-in">
                        <component :is="currentTabComponent" :key="activeTab"></component>
                      </transition>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <md-dialog-confirm
        :md-content-html="alert.content"
        :md-ok-text="alert.ok"
        ref="addPop"
      ></md-dialog-confirm>
    </b-card>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import OceanFreightSaleCard from "./OceanFreightSaleCard.vue";
import OceanFreightExpenseCard from "./OceanFreightExpenseCard.vue";
import OceanFreightReverseCard from "./OceanFreightReverseCard.vue";
import OceanFreightSaleCardAllJobs from "./OceanFreightSaleCardAllJobs.vue";
import OceanFreightJobWiseProfitLoss from "./OceanFreightJobWiseProfitLoss.vue";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      if (
        globalPermissionStatus("Accounts") ||
        globalPermissionStatus("Dashboard_Access")
      ) {
        this.$store.dispatch("setCurrentRoute", "/sale/every-day-sale-dash");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      activeTab: 0,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      tabs: [
        { name: "Expense", component: OceanFreightExpenseCard },
        { name: "Sale", component: OceanFreightSaleCard },
        { name: "ALL", component: OceanFreightReverseCard },
        { name: "ALL Jobs", component: OceanFreightSaleCardAllJobs },
        { name: "Job Wise P&L", component: OceanFreightJobWiseProfitLoss },
      ],
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
    };
  },
  components: {
    CustomLoader,
  },
  computed: {
    currentTabComponent() {
      return this.tabs[this.activeTab].component;
    },
  },
  mounted() {},
  filters: {},
  beforeDestroy() {},

  destroyed() {},
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
.modal fade show d-block {
  background: none;
}

.tab-list {
  display: flex;
  cursor: pointer;
  overflow-x: auto;
}

.tab-list div {
  padding: 10px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  white-space: nowrap;
  user-select: none;
  transition: background-color 0.3s;
}

.tab-list div:hover {
  background-color: #0aa46e;
}

.active-tab {
  background-color: #007bff;
  color: #ffffff;
}

.tab-content {
  margin-top: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-slide-enter-active,
.custom-slide-leave-active {
  transition: transform 0.5s;
}

.custom-slide-enter,
.custom-slide-leave-to {
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// Tab.vue?8f037306